<template>
    <div class="group-box">
      <div class="banner-box">
        <img class="banner" :src="require('@/assets/images/early_access_banner.png')" />
        <div class="title-box">
          <div class="title">仅需支付 <span>1</span> 元</div>
          <div class="sub-title">7天体验精选课程</div>
        </div>
      </div>
      <div class="content-box">
        <div class="main-card">
          <div class="subject-card">
            <div class="top-title">
              <div class="title-text">大家最喜欢的课程</div>
            </div>
            <div class="content">
              <div class="item" v-for="(item, index) in subjects" :key="index">
                <div class="logo" @click="navToSubject(item.id)">
                  <img :src="item.smallLogoImg" />
                </div>
                <div class="title">{{item.title}}</div>
                <div class="learned">已有 <span>{{item.pinkSalesNum + item.salesNum}}</span> 人学习</div>
                <div class="preview">
                  <div class="preview-text" @click="navToSubject(item.id)">点击试看</div>
                </div>
              </div>
              <div class="item">
                <div class="logo">
                  <img :src="require('@/assets/images/more.png')" />
                </div>
                <div class="next">
                  更多精彩课程<br />
                  敬请期待
                </div>
              </div>
            </div>
          </div>
          <div class="split">
            <img :src="require('@/assets/images/split.png')" />
          </div>
          <div class="rights-card">
            <div class="rights-title">
              <div class="rights-title-text">1元体验7天权益介绍</div>
            </div>
            <div class="left">
              <img :src="require('@/assets/images/book.png')" />
              <div class="content">
                全方位知识体系，涵盖历史、动物、文学、百科、人文等；
              </div>
            </div>
            <div class="right">
              <div class="content">
                专业团队制作打磨，帮助孩子提高知识，在快乐中学习成长；
              </div>
              <img :src="require('@/assets/images/group_people.png')" />
            </div>
            <div class="left">
              <img :src="require('@/assets/images/phone.png')" />
              <div class="content">
                仅需1元，7天内体验精选课程，任意时间想看就看；
              </div>
            </div>
          </div>
        </div>
        <div class="warning-card">
          <div class="title-box">
            <div class="title">
              购买须知
              <div class="bottom" />
            </div>
            <img :src="require('@/assets/images/earth.png')" />
          </div>
          <div class="item">
            1.每位新用户只能体验1次，只能在当前微信号中查看，已购买课程用户无法体验。<br />
            2.课程内容是【明明城堡】提供的虚拟内容服务，支付成功后无法退款，敬请谅解。<br />
            3.如遇到使用问题，可通过公众号【明明城堡】留言，我们将会为你处理。<br />
            4.明明城堡保留最终解释权。
          </div>
        </div>
      </div>
      <div v-if="user.isOneRmbTry === false && user.isBuySubject === false" class="button-box" @click="buyEarlyAccess" id="buyButton">
        <div class="button-text">1元体验精选课程</div>
      </div>
      <div v-else class="disabled-button-box">
        <div class="button-text">暂未开放体验</div>
      </div>
    </div>
</template>

<script>
import wx from 'weixin-js-sdk'
import { getSubjectsAndProfile, buyEarlyAccess, getOrderInfo } from './query.gql'
export default {
  name: 'earlyAccess',
  data() {
    return {
      user: '', // 用户信息
      subjects: [] // 课程列表
    }
  },
  async mounted() {
    console.log('1元体验7天页面')
    await this.weixinAuth()
    this.setShare() // 设置分享
    this.loadInformations() // 获取课程信息
  },
  methods: {
    random(min, max) {
      return Math.round(Math.random() * (max - min)) + min
    },
    setShare() {
      const self = this
      // 设置分享
      self.wechatShare({
        title: `已有${self.random(1600, 2800)}人参与限时体验，1元看遍精选课程！`,
        imgUrl: 'https://mmcb-pub.oss-cn-hangzhou.aliyuncs.com/mmcb-logo-v2.png',
        desc: '包含古诗、历史、人体、科学实验等精选课程[明明城堡]',
        link: `${window.location.origin}/?#/earlyAccess`
      })
    },
    loadInformations() {
      let self = this
      self.$toast.loading({
        mask: true,
        duration: 0,
        message: '加载中'
      })
      self.loadSubjects().then(res => {
        self.user = res.data.profile
        self.subjects = res.data.subjects.nodes
        self.$toast.clear()
      }).catch(err => {
        self.$toast.clear()
        console.error('page: earlyAccess。请求subjects报错', err)
      })
    },
    // 获取课程信息
    loadSubjects() {
      return this.$apollo.query({
        query: getSubjectsAndProfile,
        fetchPolicy: 'no-cache'
      })
    },
    navToSubject(id) {
      this.$router.push({
        name: 'subject',
        query: { id: id }
      })
    },
    buyEarlyAccess() {
      const self = this
      if (!(self.user.isOneRmbTry === false && self.user.isBuySubject === false)) {
        self.$toast.fail('曾购买课程')
        console.log('曾购买课程,不能下单,跳转')
        return
      }
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '提交中'
      })

      self.$apollo.mutate({
        mutation: buyEarlyAccess
      }).then(res => {
        console.log('下单结果', res)
        let result = res.data.createOrderMutation
        self.wechatPay().then(() => {
          wx.chooseWXPay({
            timestamp: result.timeStamp,
            nonceStr: result.nonceStr,
            package: result.package,
            signType: result.signType,
            paySign: result.paySign,
            success() {
              self.$toast.clear()
              self.polling(result.order.tranNo)
            },
            cancel() {
              self.$toast.clear()
              self.$toast('支付已取消')
            },
            fail() {
              self.$toast.clear()
              self.$toast.fail('支付失败')
            }
          })
        })
      }).catch(err => {
        self.$toast.clear()
        self.$toast.fail(err.graphQLErrors[0].message || '下单失败')
        console.error('page: earlyAccess。请求createOrder报错', err)
      })
    },
    // 轮询
    polling(tranNo) {
      console.log()
      const self = this
      self.$toast({
        type: 'loading',
        mask: true,
        duration: 0,
        message: '支付中'
      })
      self.showSheet = false

      let pollTimes = self.$consts.POLLING_TIMES || 5 // 默认轮询五次
      let timer = setInterval(() => {
        pollTimes -= 1
        if (pollTimes >= 0) {
          self.$apollo.query({
            query: getOrderInfo,
            variables: { tranNo },
            fetchPolicy: 'no-cache'
          }).then(res => {
            console.log('支付后', res)
            if (res.data.order.status === 'paid') {
              self.$toast.clear()
              clearInterval(timer)
              self.$router.replace({
                name: 'earlyAccessGuide'
              })
            }
          }).catch(err => {
            console.error('page: earlyAccess。（轮询）请求getOrderInfo报错', err)
          })
        } else {
          // 超过5次轮询没有结果怎么办？？
          self.$toast.clear()
        }
      }, self.$consts.POLLING_INTERVAL || 2000)
    }
  }
}
</script>

<style lang="scss" scoped>
.group-box {
  width: 100%;
  background-color: #FF9C7B;
  padding-bottom: 80px;

  .banner-box {
    width: 100%;
    position: relative;
    .banner {
      width: 100%;
    }
    .title-box {
      width: 100%;
      position: absolute;
      top: 12%;
      color: white;
      text-align: center;
      .title {
        font-size: 50px;
        font-weight: bold;
        text-shadow: 1px 4px 0px rgba(246,79,37,1);
        span {
          position: relative;
          top: 5px;
          font-size: 65px;
          color: #FFE44C;
        }
      }
      .sub-title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
      }
    }
  }

  .content-box {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    .main-card {
      width: 90%;
      margin-top: 1px;

      .subject-card {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        background-color: #FEEEE6;
        background-image: url('~@/assets/images/net_bg.png');
        background-size: cover;
        background-repeat: repeat-y;

        .top-title {
          margin: 2px;
          height: 60px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url('~@/assets/images/subject_title.png') no-repeat center center;
          background-size: contain;

          .title-text {
            font-size: 18px;
            color: white;
          }
        }

        .content {
          width: 100%;
          display: flex;
          flex-flow: row wrap;
          justify-content: flex-start;
          .item {
            width: 28%;
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 8px;
            .logo {
              width: 90%;
              height: 100%;
              img {
                width: 100%;
                border-radius: 10px;
              }
            }
            .next {
              margin-top: 8px;
              text-align: center;
              line-height: 24px;
            }
            .title {
              vertical-align: text-top;
              min-height: 36px;
              margin-top: 8px;
              font-size: 14px;
              text-align: center;
              color: #333;
              display: -webkit-box;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 2;
              /* autoprefixer: off */
              -webkit-box-orient: vertical;
            }
            .learned {
              margin-top: 6px;
              text-align: center;
              font-size: 12px;
              font-weight: 400;
              color: #666;
              span {
                color: #FF563E;
              }
            }
            .preview {
              height: 24px;
              width: 100%;
              margin-top: 8px;
              display: flex;
              align-items: center;
              justify-content: center;
              background: url('~@/assets/images/preview_btn.png') no-repeat center center;
              background-size: contain;

              .preview-text {
                font-size: 12px;
                color: white;
              }
            }
          }
        }
      }

      .split {
        height: 20px;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #FEEEE6;
        background-image: url('~@/assets/images/net_bg.png');
        background-size: cover;
        background-repeat: repeat-y;

        img {
          width: 100%;
        }
      }

      .rights-card {
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        background-color: #FEEEE6;
        background-image: url('~@/assets/images/net_bg.png');
        background-size: cover;
        background-repeat: repeat-y;
        padding-bottom: 30px;

        .rights-title {
          height: 60px;
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background: url('~@/assets/images/subject_title.png') no-repeat center center;
          background-size: contain;

          .rights-title-text {
            font-size: 18px;
            color: white;
          }
        }

        .left {
          width: 90%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;

          img {
            height: 50px;
          }

          .content {
            margin-left: 8px;
            font-weight: 400;
            font-size: 15px;
            line-height: 28px;
            color: #333333;
          }
        }

        .right {
          width: 86%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
          position: relative;

          img {
            height: 50px;
          }

          .content {
            margin-right: 8px;
            font-weight: 400;
            font-size: 15px;
            line-height: 28px;
            color: #333333;
          }
        }
      }
    }

    .warning-card {
      width: 90%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-radius: 10px;
      margin-top: 20px;
      padding-top: 30px;
      background-color: #FEEEE6;

      .title-box {
        width: 90%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .title {
          color: #FF543F;
          font-size: 26px;

          .bottom {
            margin-top: 14px;
            height:1px;
            background:rgba(255,84,63,1);
            border-radius:50%;
          }
        }

        img {
          height: 50px;
        }
      }

      .item {
        width: 90%;
        font-size: 15px;
        font-weight: 400;
        color:rgba(255,84,63,1);
        line-height: 30px;
        margin-top: 18px;
        margin-bottom: 18px;
      }
    }
  }

  .button-box {
    height: 60px;
    width: 100%;
    position: fixed;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    background: url('~@/assets/images/btn_bg.png') no-repeat center center;
    background-size: 90%;

    .button-text {
      color: white;
      font-size: 18px;
    }
  }

  .disabled-button-box {
    height: 60px;
    width: 100%;
    position: fixed;
    bottom: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 16px;
    background: url('~@/assets/images/disabled_btn_bg.png') no-repeat center center;
    background-size: 90%;

    .button-text {
      color: white;
      font-size: 18px;
    }
  }
}
</style>
